import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import { MealEditChoiceModalItem } from '../../components/MealEditChoiceModalItem/MealEditChoiceModalItem';
import { mealChoiceEditModalStore } from '../../store/mealChoiceEditModalStore';

export const MealChoiceEditModalItems: FC = memo(
  observer((): ReactElement | null => {
    if (!mealChoiceEditModalStore.sizes.length) return null;

    return (
      <ul className="pb-4">
        {mealChoiceEditModalStore.sizes.map((size, index) => (
          <MealEditChoiceModalItem key={size.id || `size-${index}`} size={size} />
        ))}
      </ul>
    );
  })
);
